import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { getFolderFiles } from '../../../../services/accounting/FinancialStatementsService';
import FileList from './FileList';

type FileListContainerProps = {
  folderID: string;
};

const FileListContainer = React.forwardRef<
  HTMLDivElement,
  FileListContainerProps
>(({ folderID }, ref) => {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: ['getFSFileList', folderID],
    queryFn: ({ signal }) => {
      return getFolderFiles(folderID, signal);
    },
    refetchOnWindowFocus: false,
  });

  if (isFetching)
    return (
      <div className="text-center mx-auto mt-3">
        <ProgressSpinner />
      </div>
    );

  if (isError)
    return (
      <ErrorMessage
        content={'Failed to obtain data! Please try again later.'}
      />
    );

  return <FileList files={data} folderID={folderID} refetchFiles={refetch} />;
});

export default FileListContainer;
